export const FehlerauswertungErrResp = (error, response) => {
    if (response) {
    const why = JSON.parse(response.text);
    if (why.code) {
        alert(`Es ist ein Fehler aufgetreten. \nCode: ${why.code}\nDetail: ${why.detail}`);
    } else {
        alert(`Es ist ein Fehler aufgetreten. \nCode: ${why.status}\nDetail: ${why.error}`);
    }
    } else {
        alert(`Unbekannter Fehler: \n${error}`);
    }

}